import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Modal, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import 'moment/locale/it';
import moment from 'moment';
import ActionButton from '../../../components/ActionButton';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '6px',
    padding: theme.spacing(3, 3, 2),
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    maxHeight: '90vh',
  },
  textfield: {
    margin: theme.spacing(1, 2),
    width: '280px',
  },
  sectionContainer: {
    border: '1px solid #e0e0e0',
    padding: theme.spacing(4, 2),
  },
  title: {
    marginBottom: 24,
    textAlign: 'center',
  },
  buttonContainer: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
});

class ModalDettagliAbbonamento extends Component {
  render() {
    const { classes } = this.props;
    const dateFormat = 'DD-MM-YYYY HH:mm';
    let modalita =
      this.props.abbonamento.pagamento !== null
        ? this.props.abbonamento.pagamento.modalita === null
          ? 'PAYPAL'
          : this.props.abbonamento.pagamento.modalita
        : '-';
    let abbonamento = this.props.abbonamento;
    if (abbonamento.pagamento === null) {
      abbonamento.pagamento = {
        id: null,
        dataCreazione: null,
        dataAggiornamento: null,
        stato: null,
        importoLordo: null,
        importoNetto: null,
        tariffaServizio: null,
        iva: null,
        nomePayer: null,
        cognomePayer: null,
        emailPayer: null,
        modalita: null,
        transazioneId: null,
        dataPagamento: null,
      };
    }

    return (
      <Modal
        open={this.props.modal}
        onClose={this.props.handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <Grid container justify="center" alignItems="center">
            <Typography variant="h5" className={classes.title}>
              Dettagli pagamento abbonamento
            </Typography>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className={classes.sectionContainer}
            >
              <Grid container>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid
                    container
                    direction="column"
                    alignItems="center"
                    style={{ paddingBottom: '10px' }}
                  >
                    <TextField
                      label="Modalità pagamento"
                      disabled
                      value={modalita}
                      className={classes.textfield}
                    />
                    <TextField
                      label="ID Pagamento"
                      disabled
                      value={abbonamento.pagamento.id || '-'}
                      className={classes.textfield}
                    />
                    <TextField
                      label="Data creazione"
                      disabled
                      value={
                        abbonamento.pagamento.dataCreazione === null
                          ? '-'
                          : moment(abbonamento.pagamento.dataCreazione).format(
                              dateFormat,
                            )
                      }
                      className={classes.textfield}
                    />
                    {modalita === 'PAYPAL' ? (
                      <TextField
                        label="Data aggiornamento"
                        disabled
                        value={
                          abbonamento.pagamento.dataAggiornamento === null
                            ? '-'
                            : moment(
                                abbonamento.pagamento.dataAggiornamento,
                              ).format(dateFormat)
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        className={classes.textfield}
                      />
                    ) : (
                      <TextField
                        label="Data pagamento"
                        disabled
                        value={
                          abbonamento.pagamento.dataPagamento === null
                            ? '-'
                            : moment(
                                abbonamento.pagamento.dataPagamento,
                              ).format(dateFormat)
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        className={classes.textfield}
                      />
                    )}
                    {modalita === 'PAYPAL' ? (
                      <TextField
                        label={'ID ordine PayPal'}
                        disabled
                        value={abbonamento.pagamento.paypalOrderId || '-'}
                        InputProps={{
                          readOnly: true,
                        }}
                        className={classes.textfield}
                      />
                    ) : (
                      <TextField
                        label={'ID transazione'}
                        disabled
                        value={abbonamento.pagamento.transazioneId || '-'}
                        InputProps={{
                          readOnly: true,
                        }}
                        className={classes.textfield}
                      />
                    )}
                    <TextField
                      label="Stato pagamento"
                      disabled
                      value={abbonamento.pagamento.stato || '-'}
                      className={classes.textfield}
                    />
                    <TextField
                      label="Importo lordo"
                      disabled
                      value={
                        abbonamento.pagamento.importoLordo === null
                          ? '-'
                          : abbonamento.pagamento.importoLordo + ' €'
                      }
                      className={classes.textfield}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid
                    container
                    direction="column"
                    alignItems="center"
                    style={{ paddingBottom: '10px' }}
                  >
                    <TextField
                      label={
                        modalita === 'PAYPAL'
                          ? 'Tariffa PayPal'
                          : 'Tariffa servizio'
                      }
                      disabled
                      value={
                        abbonamento.pagamento.tariffaServizio === null
                          ? '-'
                          : abbonamento.pagamento.tariffaServizio + ' €'
                      }
                      className={classes.textfield}
                    />
                    <TextField
                      label="IVA"
                      disabled
                      value={
                        abbonamento.pagamento.iva === null
                          ? '-'
                          : abbonamento.pagamento.iva + ' €'
                      }
                      className={classes.textfield}
                    />
                    <TextField
                      label={'Totale acquisto'}
                      disabled
                      value={
                        abbonamento.totaleNetto === null
                          ? '-'
                          : abbonamento.totaleNetto + ' €'
                      }
                      className={classes.textfield}
                    />
                    <TextField
                      label={
                        this.props.isConsulente
                          ? 'Importo netto'
                          : 'Importo incassato'
                      }
                      disabled
                      value={
                        abbonamento.pagamento.importoNetto === null
                          ? '-'
                          : abbonamento.pagamento.importoNetto + ' €'
                      }
                      className={classes.textfield}
                    />
                    <TextField
                      label="Nome acquirente"
                      disabled
                      value={abbonamento.pagamento.nomePayer || '-'}
                      className={classes.textfield}
                    />

                    <TextField
                      label="Cognome acquirente"
                      disabled
                      value={abbonamento.pagamento.cognomePayer || '-'}
                      className={classes.textfield}
                    />
                    <TextField
                      label="Email acquirente"
                      disabled
                      value={abbonamento.pagamento.emailPayer || '-'}
                      className={classes.textfield}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <div className={classes.buttonContainer}>
              <ActionButton
                label="CHIUDI"
                onClick={this.props.handleClose}
                disabled={false}
                grayVersion={false}
                secondaryButton
              />
            </div>
          </Grid>
        </div>
      </Modal>
    );
  }
}

ModalDettagliAbbonamento.propTypes = {
  classes: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  abbonamento: PropTypes.object.isRequired,
  isConsulente: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ModalDettagliAbbonamento);
